<template>
  <div class="container">
    <Search></Search>
    <CommonTab></CommonTab>
    <IndexCategory>
      <li><router-link to="/home">用户中心</router-link></li>
    </IndexCategory>
    <div class="main-content">
      <div class="layout-left">
        <div class="title">
          <span><img src="@assets/pc/images/home/people.png" alt=""/></span>
          <router-link to="/home">用户中心</router-link>
        </div>
        <div class="category">
          <div class="order">
            <div class="order-title">订单中心</div>
            <ul>
              <li
                @click="goTo('myOrder')"
                :class="nameActive === 'myOrder' ? 'active' : ''"
              >
                我的订单
              </li>
              <li
                @click="goTo('goodsCollection')"
                :class="nameActive === 'goodsCollection' ? 'active' : ''"
              >
                我的收藏
              </li>
            </ul>
            <div class="user-info order-title">用户资料</div>
            <ul>
              <li
                @click="goTo('myBalance')"
                :class="nameActive === 'myBalance' ? 'active' : ''"
              >
                我的余额
              </li>
              <li
                @click="goTo('myAddress')"
                :class="nameActive === 'myAddress' ? 'active' : ''"
              >
                收货地址
              </li>
              <li @click="goToCart">购物车</li>
              <li
                @click="goTo('verifyCenter')"
                :class="nameActive === 'verifyCenter' ? 'active' : ''"
              >
                审核中心
              </li>
              <li
                @click="goTo('contactUs')"
                :class="nameActive === 'contactUs' ? 'active' : ''"
              >
                联系我们
              </li>
              <li
                @click="goTo('myPromotion')"
                :class="nameActive === 'myPromotion' ? 'active' : ''"
              >
                我的推广
              </li>
              <li
                @click="goTo('addDoctor')"
                :class="nameActive === 'addDoctor' ? 'active' : ''"
              >
                添加醫生
              </li>
              <li
                @click="goTo('editPersonal')"
                :class="nameActive === 'editPersonal' ? 'active' : ''"
              >
                个人编辑
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="layout-right">
        <transition mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Search from "@/components/pc/Search";
import CommonTab from "@/components/pc/nav/CommonTab";
import IndexCategory from "@/components/pc/nav/IndexCategory";
export default {
  name: "Home",
  components: {
    Search,
    CommonTab,
    IndexCategory
  },
  data() {
    return {
      nameActive: ""
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {},
  methods: {
    goTo(name) {
      this.nameActive = name;
      this.$router.push(`/home/${name}`);
    },
    goToCart() {
      this.$router.push("/shoppingCart");
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  background #fff
  .main-content
    width 1200px
    margin 20px auto 0
    display flex
    .layout-left
      width 250px
      margin-right 20px
      .title
        text-align center
        line-height 59px
        border 1px solid #e3e3e3
        border-bottom 1px solid #6cc3f4
        font-size 16px
        color #555
        span
          display inline-block
          width 20px
          height 20px
          transform translateY(4px)
          margin-right 10px
          img
            width 100%
            height 100%
      .category
        border 1px solid #e3e3e3
        border-top 0
        padding 24px
        background #fcfcff
        .order
          .order-title
            font-size 14px
            color #000
            line-height 30px
          ul
            padding-left 15px
            font-size 12px
            font-family '宋体'
            color #555
            line-height 26px
            li
              cursor pointer
              &.active
                color #6cc3f4
          .user-info
            padding-top 25px
    .layout-right
      flex 1
</style>
